import axios from "axios";

//Create Passport
const createPassport = async (passport, token) => {
  const response = await axios.post("/api/v1/passport", passport, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

//Get All Passports
const getAllPassports = async (token) => {
  const response = await axios.get(`/api/v1/passport?sort=-createdAt`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

//Get Passport By Id
const getPassportById = async (id, token) => {
  const response = await axios.get(`/api/v1/passport/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

//Update Passport
const updatePassport = async (id, passport, token) => {
  const response = await axios.patch(`/api/v1/passport/${id}`, passport, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

//Delete Passport
const deletePassport = async (id, token) => {
  const response = await axios.delete(`/api/v1/passport/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

const passportService = {
  createPassport,
  getAllPassports,
  getPassportById,
  updatePassport,
  deletePassport,
};

export default passportService;
